<div class="modal fade show" tabindex="-1" role="dialog" style="display: block;" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="prorrogacaoBoletoModalLabel">
          Prorrogação de Boleto
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="documento" class="col-form-label">Documento:</label>
          <input type="text" class="form-control" id="documento" [(ngModel)]="documento" disabled />
        </div>
        <div class="form-group">
          <label for="valor" class="col-form-label">Valor do Boleto:</label>
          <input type="number" class="form-control" id="valor" step="0.01" [(ngModel)]="valor" disabled />
        </div>
        <div class="form-group">
          <label for="data-vencimento" class="col-form-label">Vencimento:</label>
          <input type="date" class="form-control" id="data-vencimento" [(ngModel)]="dataVencimento" disabled />
        </div>
        <form>
          <div class="form-group">
            <label for="nova-data" class="col-form-label">Nova Data de Vencimento:</label>
            <input type="date" class="form-control" id="nova-data" #novaData required />
          </div>
          <div class="form-group">
            <label for="motivo" class="col-form-label">Motivo:</label>
            <textarea
              class="form-control"
              id="motivo"
              #motivoProrrogacao
              required
              tooltip="No mínimo 10 caractéres"
            ></textarea>
          </div>
        </form>
        <div class="alert alert-info" role="alert">
          Você receberá um e-mail com o retorno da sua solicitação.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Fechar</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onProrrogarBoleto(novaData.value, motivoProrrogacao.value, selectedItem)"
          [disabled]="!novaData.value || !motivoProrrogacao.value || motivoProrrogacao.value.length < 10"
        >
          Solicitar Prorrogação
        </button>
      </div>
    </div>
  </div>
</div>
